import { useTranslation } from 'react-i18next';

import type { MenuSection } from '@/types';

import { SECTION_DESCRIPTIONS } from '@/components/MainMenu';
import { SidebarTrigger } from '@/components/ui/sidebar';

type SidebarSectionHeaderProps = {
  activeSection?: MenuSection;
};

export const SidebarSectionHeader = ({
  activeSection,
}: SidebarSectionHeaderProps) => {
  const { t } = useTranslation('header');

  return (
    <div className="bg-sidebar-section flex h-15 items-center gap-2.5 rounded-lg py-2 pr-2.5 pl-2 group-data-[collapsible=icon]:bg-transparent group-data-[collapsible=icon]:p-0">
      <SidebarTrigger className="bg-sidebar-pressed text-subtle-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:bg-sidebar-switcher group-data-[collapsible=icon]:hover:bg-sidebar-switcher-hover size-9 shrink-0 rounded-md [&_svg]:size-5!" />
      <div className="flex min-w-0 flex-1 flex-col group-data-[collapsible=icon]:hidden">
        {activeSection && (
          <>
            <span className="text-sidebar-accent-foreground truncate text-sm font-medium">
              {t(activeSection.label)}
            </span>
            <span className="text-muted-foreground truncate text-xs">
              {t(SECTION_DESCRIPTIONS[activeSection.key] ?? '')}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
